<script>
import {Swiper, SwiperSlide} from "swiper/vue";
import "swiper/css";

import FeedbackBlock from "@js/components/Sections/Feedbacks/Components/FeedbackBlock.vue";
import IconArrowRight from "@js/components/Icons/IconArrowRight.vue";
import {Link} from "@inertiajs/vue3";
import IconComment from "@js/components/Icons/IconComment.vue";

export default {
    name: "Feedbacks",
    components: {IconComment, Link, IconArrowRight, FeedbackBlock, Swiper, SwiperSlide},
    data() {
        return {
            slider_breakpoints: {
                640: {slidesPerView: 1},
                768: {slidesPerView: 1.5},
                1024: {slidesPerView: 2.5}
            },
            text_feedbacks: [
                {
                    name: 'Михаил Тяжельников',
                    text: 'Решил сделать подъездную дорожку к даче из ЖБИ-плит. Связался с Дмитрием, он посоветовал, какие плиты лучше подходят к неровному рельефу и сезонным перепадам температур. Договорились о доставке, всё приехало в срок. Мастера быстро уложили плиты, и теперь я могу спокойно проезжать даже на тяжёлом авто, не боясь просадок.',
                    link: 'https://yandex.com/maps/org/159145062474/reviews?reviews%5BpublicId%5D=z3w42jutteyrf00zjnmenvc4j0&utm_source=review',
                    date_formatted: '06 Февраля 2025',
                    date: '2025-02-06',
                },
                {
                    name: 'Григорий Манушакян',
                    text: 'Мы занимаемся дорожным строительством, и нам нужны были надежные дорожные плиты, соответствующие ГОСТ. Заказывали здесь крупную партию, и компания полностью оправдала ожидания. Понравился профессиональный подход – с нами работал персональный менеджер, который помог с расчетами и подбором. Все документы были оформлены оперативно, доставка точно в срок, без задержек. Качество плит – выше всяких похвал: прочный бетон, правильная геометрия, никаких дефектов. Дорогу уложили, плиты уже прошли испытание временем и нагрузками. Теперь сотрудничаем только с этим поставщиком!',
                    link: 'https://yandex.com/maps/org/159145062474/reviews?reviews%5BpublicId%5D=edxdkwxyuthdcwy2cc1e0tgbyg&utm_source=review',
                    date_formatted: '30 Января 2025',
                    date: '2025-01-30',
                },
                {
                    name: 'Kirill Bespalov',
                    text: 'Заказывал дорожные плиты для обустройства временной дороги на строительном объекте. Перед покупкой тщательно изучил предложения, сравнил цены и выбрал эту компанию по отзывам и рекомендациям. И не ошибся! Менеджер очень оперативно ответил на все вопросы, помог подобрать плиты, исходя из нагрузки и условий эксплуатации. Доставка была организована на следующий день, причем водитель прибыл точно в оговоренное время, без задержек. Плиты разгрузили аккуратно, при проверке оказалось, что каждая полностью соответствует заявленным характеристикам: ровная геометрия, никаких трещин или сколов, бетон плотный, армирование качественное. Прошло уже несколько месяцев, техника активно использует эту дорогу, плиты не проседают, не трескаются, выдерживают любые нагрузки. Однозначно рекомендую!',
                    link: 'https://yandex.com/maps/org/159145062474/reviews?reviews%5BpublicId%5D=z6c75trrwdnp5r2mrdupmt1fxr&utm_source=review',
                    date_formatted: '02 Февраля 2025',
                    date: '2025-02-02',
                },
                {
                    name: 'Михаил Я.',
                    text: 'Мы долго искали поставщика, у которого можно купить дорожные плиты без переплат. Здесь цены оказались адекватными, а качество – на высшем уровне. Плиты привезли без задержек, документы предоставили сразу. Проверили каждую – все соответствуют ГОСТ, без дефектов. Уже использовали их на объекте, выдерживают тяжелую технику без малейших проблем. Теперь работаем только с этой компанией. Спасибо за честность и профессионализм!',
                    link: 'https://yandex.com/maps/org/159145062474/reviews?reviews%5BpublicId%5D=dfm626a5pnzhb17x21v0kj1w3c&utm_source=review',
                    date_formatted: '31 Января 2025',
                    date: '2025-01-31',
                },
            ],
            swiper: null,
        };
    },
    methods: {
        setSwiper(swiperInstance) {
            this.swiper = swiperInstance;
        },
        slideNext() {
            if (this.swiper) this.swiper.slideNext();
        },
        slidePrev() {
            if (this.swiper) this.swiper.slidePrev();
        },
        insertSchemaMarkup() {
            if (typeof window !== "undefined") {
                const scriptId = "schema-reviews-jsonld"
                let script = document.getElementById(scriptId)

                if (script) {
                    script.remove()
                }

                script = document.createElement("script")
                script.id = scriptId
                script.type = "application/ld+json"
                script.textContent = JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "ItemList",
                    "itemListElement": this.text_feedbacks.map((feedback, index) => ({
                        "@type": "Review",
                        "author": {
                            "@type": "Person",
                            "name": feedback.name
                        },
                        "datePublished": feedback.date,
                        "reviewBody": feedback.text,
                        "url": feedback.link,
                        "reviewRating": {
                            "@type": "Rating",
                            "ratingValue": 5,
                            "bestRating": 5
                        }
                    }))
                })

                document.head.appendChild(script);
            }
        },
        removeSchemaMarkup() {
            const script = document.getElementById("schema-reviews-jsonld")
            if (script) {
                script.remove()
            }
        }
    },
    mounted() {
        this.insertSchemaMarkup()
    },
    beforeUnmount() {
        this.removeSchemaMarkup()
    },
};
</script>

<template>
    <div>
        <div class="container">
            <div class="mb-10">
                <h2 class="text-2xl md:text-3xl font-semibold text-left">
                    Отзывы компании
                </h2>
            </div>
            <Swiper :slides-per-view="1"
                    :space-between="20"
                    @swiper="setSwiper"
                    :loop="true"
                    :breakpoints="slider_breakpoints"
                    class="mb-8 w-full">
                <SwiperSlide v-for="(feedback, index) in text_feedbacks" :key="index">
                    <FeedbackBlock :link="feedback.link" :text="feedback.text" :name="feedback.name"
                                   :date="feedback.date_formatted"/>
                </SwiperSlide>
            </Swiper>

            <!-- Навигационные кнопки -->
            <div class="flex items-center justify-between w-full">
                <div>
                    <Link :href="route('otzyvy')"
                          class="flex justify-center items-center  text-white hover:text-indigo-600 border-2 border-indigo-600 bg-indigo-600 hover:bg-transparent font-medium rounded-lg text-base px-5 md:px-10 py-2 focus:outline-none transition">
                        <IconComment class="w-5 h-5 me-3"/>
                        Все отзывы
                    </Link>
                </div>
                <div class="flex space-x-3">
                    <button @click="slidePrev" aria-label="Назад"
                            class="border-2 border-indigo-600 active:bg-indigo-600 active:text-white text-indigo-600 rounded-full w-10 h-10 flex items-center justify-center transition">
                        <IconArrowRight class="w-6 h-6 rotate-180"/>
                    </button>
                    <button @click="slideNext" aria-label="Вперед"
                            class="border-2 border-indigo-600 active:bg-indigo-600 active:text-white text-indigo-600 rounded-full w-10 h-10 flex items-center justify-center transition">
                        <IconArrowRight class="w-6 h-6"/>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
